import { ALBUM_SUBTYPE } from '../../../../../constants/albums';

export const FREEMIUM_EVENT_TUTORIAL_STEPS = {
  PHOTO_ALBUMS: 'PHOTO_ALBUMS',
  GROUP_VIDEO_SETUP: 'GROUP_VIDEO_SETUP',
  PERMISSIONS: 'PERMISSIONS',
  QR_CODE_DOWNLOAD: 'QR_CODE_DOWNLOAD',
  JOIN_CODE: 'JOIN_CODE',
  MEMORY_BOOK_SETUP: 'MEMORY_BOOK_SETUP',
  SOCIAL: 'SOCIAL',
  INVITE: 'INVITE',
};

export const freemiumEventTutorialWizardStrings = {
  [ALBUM_SUBTYPE.BIRTHDAYS]: {},
  [ALBUM_SUBTYPE.ANNIVERSARIES]: {},
  [ALBUM_SUBTYPE.GRADUATIONS]: {},
  [ALBUM_SUBTYPE.MEMORIALS]: {},
  [ALBUM_SUBTYPE.VACATIONS]: {},
  [ALBUM_SUBTYPE.FUNDRAISERS]: {},
  [ALBUM_SUBTYPE.CUSTOM_EVENT]: {},
  [ALBUM_SUBTYPE.WEDDINGS]: {},
};
